//import React, {Component} from 'react'
import store from './store';
import { Routes, Route, Router } from "react-router-dom";
import { Provider } from 'react-redux';
import RegistroNuevoUsuario from "./Register";
import Protected from './Protected';
import Dashboard from './Dashboard';
import Areas from './Areas';

import Users from './Users';
import Login from './Login';
import Competencias from './Competencias';
import Organigramas from './Organigramas';
import ViewUserProfile from './ViewUserProfile';

import NewAreaN1 from './NewAreaN1';
import NewUser from './NewUser';
import NewCompetencia from './NewCompetencia';

import EditAreaN1Page from './EditAreaN1Page'
import EditAreaN2Page from './UpdateAreaN2';
import EditOrganigramaAreas from './UpdateOrganigramaCompetencia';
import NewOrganigrama from './NewOrganigrama';
import EditOrganigramaAreasN2 from './UpdateOrganigramaAreasN2';
import EditOrganigramaPosiciones from './UpdateOrganigramaPosiciones';
import ListaDeJueces from './ListaDeJueces';
import ListaDeCompetenciasUsuario from './ListaDeCompetenciasUsuario';

import Profile from './Profile';

const MainRoutes = (props) => ( 
  <>
  <Provider store={store}>    
    
    <Routes>     
      
      <Route path="/">
        <Route element={<Protected />}>
          <Route index element={<Dashboard />} />
          <Route exact path="dashboard" element={<Dashboard />} />
          <Route exact path="admin-users" element={<Users />} />
          <Route exact path="competencias" element={<Competencias />} />
          <Route exact path="areas" element={<Areas />} />
          <Route exact path="organigramas" element={<Organigramas />} />
          <Route exact path="viewuserprofile/:userid" element={<ViewUserProfile />} />

          <Route exact path="editarean1page/:id" element={<EditAreaN1Page />} />
          <Route exact path="editarean2page/:id" element={<EditAreaN2Page />} />
          <Route exact path="editorganigramaareas/:id" element={<EditOrganigramaAreas />} />
          <Route exact path="editorganigramaareasn2/:childid/:idorganigramaarea" element={<EditOrganigramaAreasN2 />} />
          <Route exact path="editorganigramaposiciones/:childid/:idorganigramaarea" element={<EditOrganigramaPosiciones />} />

          <Route exact path="listadejuecescompetencia/:organigramaid/:competenciaid/:userid" element={<ListaDeJueces />} />
          <Route exact path="listofcompetenciasusuario/:userid" element={<ListaDeCompetenciasUsuario />} />

          <Route exact path="new-competencia" element={<NewCompetencia />} />      
          <Route exact path="new-user" element={<NewUser />} />      
          <Route exact path="new-arean1" element={<NewAreaN1 />} />
          <Route exact path="new-organigrama" element={<NewOrganigrama />} />
          <Route exact path='userprofile' element={<Profile user = {props.user}/>} />

          <Route path="*" element={<h1>Page not found</h1>} />
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="auto-register" element={<RegistroNuevoUsuario />} />
        <Route path="*" element={<h1>Page not found</h1>} />
      </Route> 
            
      {/**
      <Route path="*" element={<h5>Page not found</h5>} />
      
      <Route exact path="/admin-users" element={<Users />} />
      <Route exact path="/new-user" element={<NewUser />} />      
      <Route exact path="/login" element={<Login />} />      
      <Route exact path="/dashboard" element={<ExportSidebar />} />
      <Route exact path="/auto-register" element={<RegistroNuevoUsuario />} />
      */}
      
    </Routes>
  </Provider>
  </>
);



export default MainRoutes;

